import React from 'react';
import { string } from 'prop-types';

const ImplementIdle = ({
  className = '',
  color = '#696f88',
}) => (
  <svg className={className} width="1.4rem" height="1.4rem" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.17301 7.87329H6.28556C6.64856 8.22116 7.06111 8.51718 7.51204 8.75H4.95825L4.66659 9.91667H8.16659L7.9222 8.94027C8.31753 9.10277 8.73691 9.2179 9.17375 9.27979L9.33325 9.91667H10.4999V9.29972C11.1097 9.23229 11.6878 9.06101 12.2163 8.80298C12.2378 8.8789 12.2499 8.95885 12.2499 9.04167V11.9583C12.2499 12.4417 11.8581 12.8333 11.3749 12.8333C10.8917 12.8333 10.4999 12.4417 10.4999 11.9583V11.0833H9.33325V12.8333L8.16659 14V11.0833H6.99992V12.8333L5.83325 14V11.0833H4.66659V12.8333L3.49992 14V11.0833H2.33325V11.9583C2.33325 12.4417 1.94147 12.8333 1.45825 12.8333C0.975037 12.8333 0.583252 12.4417 0.583252 11.9583V9.04167C0.583252 8.55831 0.975037 8.16667 1.45825 8.16667C1.94147 8.16667 2.33325 8.55831 2.33325 9.04167V9.91667H3.49992L4.00863 7.88241L2.84481 3.20605H4.01147L5.17301 7.87329Z" fill={color} />
    <path d="M11.6666 4.66667H8.16659V3.5H11.6666V4.66667Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M9.91659 0C12.1717 0 13.9999 1.82817 13.9999 4.08333C13.9999 6.3385 12.1717 8.16667 9.91659 8.16667C7.66142 8.16667 5.83325 6.3385 5.83325 4.08333C5.83325 1.82817 7.66142 0 9.91659 0ZM9.91659 1.16667C8.30576 1.16667 6.99992 2.4725 6.99992 4.08333C6.99992 5.69416 8.30576 7 9.91659 7C11.5274 7 12.8333 5.69416 12.8333 4.08333C12.8333 2.4725 11.5274 1.16667 9.91659 1.16667Z" fill={color} />
  </svg>

);

ImplementIdle.propTypes = {
  className: string,
  color: string,
};

export default ImplementIdle;
